import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import ErrorIcon from "@material-ui/icons/Error";

const useStyles = makeStyles({
  root: {
    fontFamily: "Source Sans Pro",
  },
  closeButton: {
    position: "absolute",
    right: 1,
    top: 1,
    color: "#707070",
  },
  content: {
    paddingBottom: 45,
    fontFamily: "Source Sans Pro",
    fontSize: "16px",
  },
  okbutton: {
    borderRadius: 2,
    backgroundColor: "#008381",
    textTransform: "none",
    fontWeight: 500,
    fontFamily: "Source Sans Pro",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#008381",
      textTransform: "none",
      boxShadow: "none",
    },
    width: 90,
  },
  title: {
    fontFamily: "Source Sans Pro",
    fontWeight: 600,
    marginTop: 18,
    fontSize: "20px"
  },
  hr: { width: "100%", color: "#707070" },
  error: { color: "#c53535", height:"24px", width: "24px", fontSize: "20px", marginTop: 18 },
  dialog: {
    minWidth: "444px",
    minHeight: "230px"
  }
});

export default function SelectOrgErrorDialogBox(props: {
  state: boolean;
}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(props.state);

  const handleClose = () => {
    window.history.replaceState(null, '', '/residents')
    setOpen(false);
  };
  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        onBackdropClick={handleClose}
        onClose={handleClose}
      >
        <DialogTitle id="alert-dialog-title">
          <ErrorIcon className={classes.error} />
          <span className={classes.title} > There was a problem linking to this aged care provider</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
          disableRipple
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText
            className={classes.content}
            id="alert-dialog-description"
          >
            We have experienced an issue linking you to the aged care provider.
          </DialogContentText>
        </DialogContent>
        <hr className={classes.hr} />
        <DialogActions>
          <Button
            variant="contained"
            size="medium"
            className={classes.okbutton}
            onClick={handleClose}
            color="primary"
            disableRipple
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
